import { Box, Fade, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Aos from "../../components/Aos";
import CartModal from "../../components/CartModal/CartModal";
import Footer from "../../components/Footer/Footer";
import PopUp from "../../components/PopUp/PopUp";
import RentalItemFilterModal from "../../components/RentalItemFilterModal/RentalItemFilterModal";
import RequestOrder from "../../components/RequestOrder/RequestOrder";
import {
  CUSTOMER,
  SELLABLE_PRODUCT,
  SELLABLE_SERVICE,
} from "../../config/constants";
import ProductDetails from "../../pages/CustomerProducts/components/ProductDetails";
import ServiceDetails from "../../pages/OtherServices/components/ServiceDetails";
import { userIsAuthenticated } from "../../stateManagement/helpers";
import {
  IAuthState,
  IUser,
  resetLoggedOut,
  tryConfirmLogin,
} from "../../stateManagement/reducers/authReducer";
import {
  closeCart,
  ICartState,
  openCart,
} from "../../stateManagement/reducers/cartReducer";
import { tryFetchActiveMembership } from "../../stateManagement/reducers/ordersReducer";
import {
  closeRentalItemFilter,
  IRentalItem,
  IRentalItemsState,
  setFavouriteRentalItems,
  toggleRentalItemFilter,
} from "../../stateManagement/reducers/rentalItemsReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import Background from "./Background";
import Header from "./components/Header";

const GeneralLayout = () => {
  const dispatch = useDispatch<any>();
  const { user, authToken, realRole, loggedOut } = useSelector<
    IRootReducerT,
    IAuthState
  >((state) => state.auth);
  const location = useLocation();
  const [favItems, setFavItems] = useState<IRentalItem[]>([]);

  const { isRentalItemFilterOpen, isRentalItemSearchOpen, mainRentalItem } =
    useSelector<IRootReducerT, IRentalItemsState>((state) => state.rentalItems);

  const [isItemFilterOpen, setIsItemFilterOpen] = useState(
    isRentalItemFilterOpen,
  );

  const setItemFilterOpen = (truth: boolean) => {
    dispatch(toggleRentalItemFilter());
  };

  const [closeItemFilter, setCloseItemFilter] = useState(
    !isRentalItemFilterOpen,
  );

  const { isCartOpen } = useSelector<IRootReducerT, ICartState>(
    (state) => state.cart,
  );

  const [show, setShow] = useState(false);

  const [showRentalOrderRequestForm, setShowRentalOrderRequestForm] =
    useState(false);

  const [isInitRender, setIsInitRender] = useState(true);
  useEffect(() => {
    if (isInitRender) {
      setIsInitRender(false);
      return;
    }

    setShow(false);
  }, [isInitRender, location.pathname]);

  useEffect(() => {
    if (!show) {
      setTimeout(() => {
        setShow(true);
      }, 0);
    }
  }, [show]);

  useEffect(() => {
    if (user?.role && realRole && user.role.name !== realRole.name) {
      return;
    }

    if (user && user?.role?.name === CUSTOMER) {
      dispatch(tryFetchActiveMembership({ authToken: authToken ?? "" }));

      if (userIsAuthenticated(user as IUser)) {
      }
    }
  }, [user]);

  useEffect(() => {
    if (user?.role && realRole && user.role.name !== realRole.name) {
      return;
    }

    dispatch(
      tryConfirmLogin({
        authToken: authToken ?? "",
        setFavouriteRentalItems: setFavItems,
      }),
    );
  }, []);

  useEffect(() => {
    if (favItems.length > 0) {
      dispatch(setFavouriteRentalItems(favItems));
    }
  }, [favItems]);

  const [isInitRender120, setIsInitRender120] = useState(true);
  useEffect(() => {
    if (isInitRender120) {
      setIsInitRender120(false);
      dispatch(resetLoggedOut({ authToken: authToken ?? "" }));
      return;
    }
  }, [loggedOut]);

  const [showCartModal, setShowCartModal] = useState(isCartOpen);
  const [closeCartModal, setCloseCartModal] = useState(!isCartOpen);

  const setIsCartOpen = (truth: boolean) => {
    truth ? dispatch(openCart()) : dispatch(closeCart());
  };

  useEffect(() => {
    if (showCartModal) {
      setCloseCartModal(false);
    } else {
      setTimeout(() => setCloseCartModal(true), 500);
    }
  }, [showCartModal]);

  useEffect(() => {
    if (isCartOpen) {
      setShowCartModal(true);
      setCloseCartModal(false);
    } else {
      setShowCartModal(false);
      setTimeout(() => setCloseCartModal(true), 500);
    }
  }, [isCartOpen]);

  useEffect(() => {
    if (isRentalItemFilterOpen) {
      setCloseItemFilter(false);
    } else {
      setTimeout(() => setCloseItemFilter(true), 500);
    }
  }, [isRentalItemFilterOpen]);

  useEffect(() => {
    if (isRentalItemFilterOpen) {
      setIsItemFilterOpen(true);
      setCloseItemFilter(false);
    } else {
      setIsItemFilterOpen(false);
      setTimeout(() => setCloseItemFilter(true), 500);
    }
  }, [isRentalItemFilterOpen]);

  useEffect(() => {
    if (closeItemFilter) {
      setTimeout(() => dispatch(closeRentalItemFilter()), 500);
    }
  }, [closeItemFilter]);

  return (
    <>
      <Stack
        id="generalBody"
        alignItems="center"
        width={"100%"}
        spacing={4}
        sx={{
          display: "flex",
          backgroundColor: "#f8f8f6",
          position: "relative",
          overflow: "hidden",
          minHeight: "100vh",
          p: 0,
          pt: 0,
          pb: 0,
        }}
      >
        <Aos />
        <Header setShowCartModal={setIsCartOpen} />
        <Fade
          in={show}
          style={{
            transitionDelay: show ? "250ms" : "0ms",
            transitionDuration: "500ms",
          }}
        >
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: {
                xs: 0,
                sm: 0,
              },
              position: "relative",
              pb: "0 !important",
              display: "flex",
              width: "100%",
              minHeight: {
                xs: "100vh",
                md: "100vh",
              },
              marginTop: "0 !important",
              overflow: "hidden",
            }}
          >
            <Background />

            {show && <Outlet />}
          </Box>
        </Fade>
        <Footer />
      </Stack>
      {!closeCartModal && (
        <CartModal
          isModalOpen={showCartModal}
          openModal={setIsCartOpen}
          showOrderPlacementModal={() => {
            setShowRentalOrderRequestForm(true);
          }}
        />
      )}
      {!closeItemFilter && (
        <RentalItemFilterModal
          isModalOpen={isItemFilterOpen}
          openModal={setItemFilterOpen}
          showOrderPlacementModal={() => {
            setShowRentalOrderRequestForm(true);
          }}
        />
      )}
      {mainRentalItem?.type === SELLABLE_PRODUCT && (
        <ProductDetails rentalItem={mainRentalItem} />
      )}
      {mainRentalItem?.type === SELLABLE_SERVICE && (
        <ServiceDetails rentalItem={mainRentalItem} />
      )}
      {user && (
        <PopUp
          id="customerRequestRentalOrderRequest"
          deployed={showRentalOrderRequestForm}
          setDeployed={setShowRentalOrderRequestForm}
        >
          <RequestOrder
            user={user as IUser}
            setOpened={setShowRentalOrderRequestForm}
          />
        </PopUp>
      )}
    </>
  );
};

export default GeneralLayout;
